<template>
  <NodeViewWrapper
    as="div"
    draggable="false"
    @click="onSelectNode"
  >
    <Attachment
      v-if="!isBase64"
      :node="node"
      :editor="editor"
      :updateAttributes="updateAttributes"
      :getPos="getPos"
    />
  </NodeViewWrapper>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Editor } from "@tiptap/core"
import { Node as ProseMirrorNode } from "@tiptap/pm/model"
import { NodeViewWrapper } from "@tiptap/vue-3"

import Attachment from "@/components/Attachment/index.vue"

import { TypeConfig } from "@/models"

@Options({
  name: "EditorAttachment",
  components: {
    NodeViewWrapper,
    Attachment
  }
})
export default class EditorAttachment extends Vue {
  @Prop() node: ProseMirrorNode
  @Prop() editor: Editor
  @Prop() updateAttributes: (attributes: Record<string, any>) => void
  @Prop() getPos: () => number
  @Prop() config: TypeConfig | null

  get isBase64() {
    return this.node.attrs.type === "base64"
  }

  onSelectNode() {
    this.editor.commands.selectParentNode()
  }
}
</script>
